<template>
  <div class="d-flex input-wrapper">
    <div class="calendar-icon-wrapper">
      <GjIcon
        name="Calendar"
        class="calendar-icon"
      />
    </div>
    <flat-pickr
      v-model="computedDateRange"
      class="form-control"
      :disabled="loading"
      :spinning="true"
      :config="dateRangeConfigs"
      @on-close="saveDate"
    />
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    flatPickr,
  },
  data() {
    const isoDate = new Date()
    const tomorrowDate = this.formatOffsetDateTime(new Date(isoDate.setDate(isoDate.getDate() + 1)))
    const oneYearAgo = new Date(isoDate.setFullYear(isoDate.getFullYear() - 1))

    return {
      dateRange: null,
      dateRangeConfigs: {
        mode: 'range',
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        minDate: this.formatOffsetDateTime(oneYearAgo),
        maxDate: tomorrowDate,
        minuteIncrement: 1,
      },
    }
  },
  computed: {
    storedDateRange() {
      return this.$store.state.healthcheckLogs.dateRange
    },
    loading() {
      return this.$store.state.healthcheckLogs.fetchingHealthcheckStats
    },
    healthcheckStats() {
      return this.$store.state.healthcheckLogs.healthcheckStats
    },
    healthcheck() {
      return this.$store.state.healthchecks.healthcheck
    },
    computedDateRange: {
      get() {
        return `${this.formatOffsetDateTime(this.storedDateRange.dateFrom)} 
        to ${this.formatOffsetDateTime(this.storedDateRange.dateTo)}`
      },
      set(dateRange) {
        this.dateRange = dateRange
      },
    },
  },
  created() {
    this.dateRange = `${this.formatOffsetDateTime(this.storedDateRange.dateFrom)} 
        to ${this.formatOffsetDateTime(this.storedDateRange.dateTo)}`
  },
  methods: {
    saveDate(e) {
      if (e.length === 0) return

      const formattedDate = this.splitString(this.dateRange)
      this.$store.commit('healthcheckLogs/SET_DATE_RANGE', { ...formattedDate, healthcheckId: this.healthcheck.id })
      this.$emit('onUpdate', formattedDate)
    },
    splitString(date) {
      const parts = date.split(' to ')
      return {
        dateFrom: this.formatDate(parts[0]),
        dateTo: this.formatDate(parts[1]),
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      return date.toISOString()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/../GjirafaFront/style/theme.scss";

.input-wrapper{
  .form-control {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    min-width: 20rem !important;
    ::v-deep{
      margin-right: 0px;
      margin-bottom: 0px !important;
    }
  }
  .calendar-icon-wrapper {
    display: flex;
    border: 1px solid $gray-300;
    border-radius: 2px 0 0 2px !important;

    .calendar-icon {
      margin: 0 5px;
      height: 100%;
      display: flex;
      vertical-align: middle;
    }
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
